/** @jsxImportSource @emotion/react */
import colors from '@sportninja/common/constants/appColors'

interface MoveTradeIconProps {
  size?: number
  color?: string
  className?: string
}

const MoveTradeIcon = ({
  size = 16,
  color = colors.SECONDARY_300,
  className,
}: MoveTradeIconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      className={className}
    >
      <path
        d='M6.99 11L3 15L6.99 19V16H14V14H6.99V11ZM21 9L17.01 5V8H10V10H17.01V13L21 9Z'
        fill={color}
      />
    </svg>
  )
}

export default MoveTradeIcon
